import { useState } from "react";
import { Button, Modal, Select, Group, Stack } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { useMutation, useQuery } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { getCoordinators } from "../../../../services/user";
import { useCheckPermission } from "../../../../hooks/useCheckPermission";
import { assignTo } from "../../../../services/flag";
import { useDispatch } from "react-redux";
import { updateRow } from "../../../../redux/features/monitoringQueue/monitoringQueueSlice";

export default function AssignTo({ flagId }) {
  const dispatch = useDispatch();
  const [opened, { open, close }] = useDisclosure(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const assignToPermission = useCheckPermission("ASSIGN_TO");

  const { data: coordinators } = useQuery({
    queryKey: ["coordinators"],
    queryFn: getCoordinators,
    staleTime: 5 * 60 * 1000, // 5 minutes no refetching coordinators
  });

  const options = coordinators?.map((e) => ({
    label: `${e.name} - assigned flags - ${e.pendingFlags}`,
    value: String(e.id),
  }));

  const mutation = useMutation({
    mutationFn: () => assignTo({ flagId, userId: selectedUser }),
    onSuccess: ({ data }) => {
      dispatch(updateRow(data));
      toast.success("Flag successfully assigned.");
      close();
    },
    onError: (err) => {
      toast.error(err.response?.data?.message);
    },
  });

  if (!assignToPermission) return null;

  return (
    <>
      <Button
        variant="outline"
        onClick={(e) => {
          e.stopPropagation();
          open();
        }}
        size="xs"
      >
        Assign to
      </Button>

      <Modal opened={opened} onClose={close} title="Assign to" centered>
        <Stack>
          <Select
            placeholder="Select a coordinator"
            data={options}
            value={selectedUser}
            onChange={setSelectedUser}
          />
          <Group justify="space-between">
            <Button variant="outline" color="red" onClick={close}>
              Cancel
            </Button>
            <Button
              variant="outline"
              color="green"
              onClick={() => mutation.mutate()}
              disabled={!selectedUser}
              loading={mutation.isPending}
            >
              Confirm
            </Button>
          </Group>
        </Stack>
      </Modal>
    </>
  );
}
